<div class="all-content">
  <div class="top">
    {{ getLanguages('personas') }}
  </div>
  <div class="row">
    <div class="div-search" [ngClass]="isSearch ? 'div-search-fixed' : ''">
      <div class="search">
          <input type="text" [(ngModel)]="text" (keyup.enter)="searchNodes()">
          <i class="fas fa-xmark cancel-search" *ngIf="isSearch" (click)="clearFilter()"></i>
      </div>
      <button (click)="searchNodes()">
          {{ getLanguages('search') }}
      </button>

      <div class="filter-section count-proccess" *ngIf="isSearch">
        <div class="filter" *ngIf="filterArray?.length > 0">
          {{ filterCursor }}           
          {{ getLanguages('businessSolution/search/of') }}        
          {{ filterArray?.length }}
          <button class="button-navigation" (click)="previous()" [class.disabled-button-filter]="filterCursor === 1" [disabled]="filterCursor === 1"> <i class="fas fa-chevron-left"></i> </button>
          <button class="button-navigation" (click)="next()"  [class.disabled-button-filter]="filterCursor === filterArray.length" [disabled]="filterCursor === filterArray.length"> <i class="fas fa-chevron-right"></i> </button>
        </div>
        <span *ngIf="filterArray?.length == 0">
          {{ getLanguages('businessSolution/search/noResult') }}        
        </span>
      </div>  
    </div>
    <div class="div-buttons">
      <button (click)="toggleUploadChooseReference()" class="button-tooltip left-button" [disabled]="isEdited" matTooltip="{{ getLanguages('personas/choose_reference/label') }}" [ngClass]="isEdited ? 'disabled no-pointer' : ''" *ngIf="getSystemPermission('organizational_structure', 'choose_reference_personas')">
        {{ getLanguages('personas/choose_reference') }}
      </button>
      <div class="button-save">
          <button (click)="saveTree()" matTooltip="{{ getLanguages('save') }}" [disabled]="!isEdited" class="save button-tooltip" [ngClass]="!isEdited ? 'disabled no-pointer' : ''" *ngIf="getSystemPermission('organizational_structure', 'save_structure')">
            {{ getLanguages('saveChangesTree') }}
          </button>
      </div>
      <button (click)="toggleUpload()" class="button-tooltip left-button" matTooltip="{{ getLanguages('businessSolution/top/info/import') }}" *ngIf="getSystemPermission('organizational_structure', 'import')">
        {{ getLanguages('businessSolution/top/info/import') }}
      </button>
      <div class="button-save" *ngIf="getSystemPermission('organizational_structure', 'export')">
        <button class="save" [matMenuTriggerFor]="selectExport" *ngIf="filesOld && filesOld.length > 0">
          {{ getLanguages('businessSolution/top/info/export') }}
          <i class="fas fa-angle-down" style="margin-left: 2vh;"></i>
        </button>
        <mat-menu #selectExport="matMenu">
          <button (click)="getTreeXls('json')" class="menu-button">
            {{ getLanguages('businessSolution/top/info/export/json') }}
          </button>
          <button (click)="getTreeXls('xls')" class="menu-button">
            {{ getLanguages('businessSolution/top/info/export/xls') }}
          </button>
        </mat-menu>
      </div>
    </div>
  </div>

  <div class="content">
    <div class="title">
      <span>
        {{ getLanguages('personas/tree') }}
      </span>
      <i class="fa-solid fa-chevron-right" [ngClass]="!openTree ? 'openned' : 'closed'" (click)="flipTree()"></i>
      <i class="fas fa-plus" (click)="loadModal(1)" *ngIf="getSystemPermission('organizational_structure', 'create')"></i>
    </div>
  <div class="content-content" style="margin-top: 1vh;">
    <div class="tree" [ngStyle]="{'width': isResponsive() && (isShow || isShowEdit) ? '50%' : '50%'}">
      <div class="noData" *ngIf="noData && !isLoading">
        <div class="icon">
            <i class="fa-solid fa-exclamation"></i>
        </div>
        <span>
            {{ getLanguages('errors/noData')}}
        </span>

        <b> {{ getLanguages('personas/import') }} </b>


        <button class="button-menu" [matMenuTriggerFor]="slaUnitMenu">
          <span>
            {{ selectedCorporationPeronas?.name ? selectedCorporationPeronas.name : getLanguages('select') }}
          </span>
          <i class="fa-solid fa-caret-down"></i>
        </button>

        <mat-menu #slaUnitMenu="matMenu">
          <div class="menu">
            <div class="input" (click)="$event.stopPropagation()">
              <input type="text" [(ngModel)]="searchCorporationPersonas" placeholder="{{ getLanguages('search') }}">
              <i class="fa-solid fa-magnifying-glass"></i>
            </div>
            <div class="scroll">
              <ng-container *ngFor="let corporationPersona of corporationPersonasArray">
                <ng-container *ngIf="corporationPersona.name.toLowerCase().includes(searchCorporationPersonas.toLowerCase())">
                  <div class="item-menu" (click)="choseItemSelect('corporationPersona', corporationPersona)">
                    <span [ngClass]="corporationPersona?.uuid == selectedCorporationPeronas?.uuid ? 'valid-span' : 'invalid-span' ">
                      {{ corporationPersona.name }}
                    </span>
                  </div>
                </ng-container>
              </ng-container>
            </div>
          </div>
        </mat-menu>
  

      </div>
      <p-tree class="ptree"
        [value]="files"
        *ngIf="!isLoading && !noData"
        selectionMode="single"
        [(selection)]="selectedFile"
        (onNodeSelect)="loadModal(2, $event)"
        >
          <ng-template let-node pTemplate="default">
            <div class="pcontent">
              <section>
                <div class="ptitle">
                  <i class="fas" [ngClass]="getIcon(node.data.type)"></i>
                  <div class="button-tooltip" [ngClass]="{
                      'error-name': node?.error,
                      'title-destak': filterArray.includes(node.uuid)
                    }">
                    {{ node?.label ?? '' }} 
                    <i *ngIf="node?.error" class="fa-solid fa-triangle-exclamation error-icon"></i>
                  </div>
                </div>
                <div class="toggle-tooltip" *ngIf="node?.error">
                  <div *ngIf="node?.error" class="item-op">
                    {{ getLanguages('errors/personas/' + node?.error) }}
                  </div>
                </div>
              </section>
              <div class="picons">
                  <div class="button" matTooltip="{{ getLanguages('personas/delete') }}" (click)="showDeleteItemModal(node, $event)"
                  *ngIf="getSystemPermission('organizational_structure', 'delete') && (!node.children || node.children.length == 0) && (!node.clones || node.clones.length == 0)">
                    <i class="fas fa-trash i"></i>
                  </div>
                  <div class="button" matTooltip="{{ getLanguages('personas/add') }}" (click)="loadModal(1, node, $event)"
                    *ngIf="getSystemPermission('organizational_structure', 'create') && node.data.type == 'organogram'">
                    <i class='fas fa-plus i'></i>
                  </div>
              </div>
            </div>
          </ng-template>
        </p-tree>
      </div>
      <div class="form-modal"  *ngIf="isShow || isShowEdit" [ngStyle]="{'width': !isResponsive() ? '100%' : 'calc(50% - 1vh)'}">
        <app-personas-crud *ngIf="isShow"  (toggleModal)="loadModal(0)" (getPersonasTree)="getPersonasTree()" [properties]="properties" [parameters]="objectModal" (updateFiles)="updateFiles($event)"></app-personas-crud>
        <app-personas-crud *ngIf="isShowEdit" (toggleModal)="loadModal(0)" (getPersonasTree)="getPersonasTree()" [properties]="properties" [parameters]="objectModal" (updateFiles)="updateFiles($event)"></app-personas-crud>
      </div>
    </div>
  </div>
</div>

<div class="background-modals" *ngIf="isShowDelete || isLoading || isShowImport || isShowChooseReference">
  <app-import *ngIf="isShowImport" (toggleImportModal)="toggleUpload()" (updateFiles)="updateFiles($event)" [properties]="properties" [parameters]="parameters" [type]="'organizational_structure'"> </app-import>
  <app-loading *ngIf="isLoading"></app-loading>
  <app-delete-component *ngIf="isShowDelete" (toggleDelete)="openCloseModalDelete(false)" (updateFiles)="updateFiles($event)" [parameters]="objectModal" [type]="4"></app-delete-component>
  <app-choose-reference-personas *ngIf="isShowChooseReference" (toggleModal)="toggleUploadChooseReference($event)" [referenceTreeShared]="referenceTreeShared"></app-choose-reference-personas>
</div>
